/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
import { classNames } from 'shared/lib/classNames/classNames';
import React, { useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { useApi } from 'app/api/APIProvider';
import { useDispatch, useSelector } from 'react-redux';
import { getCart, getCurrentInCart } from 'features/User/modal/selectors/getUserData/getUserData';
import { userActions } from 'features/User';
import { formatNumber } from 'shared/lib/utils/utils';
import { images } from '../api/images';
import img from 'shared/assets/img/pages/girl-image.png';
import CardPlug from 'shared/assets/img/pages/card-plug.png';
import Cart from 'shared/assets/icons/Cart.svg';
import Minus from 'shared/assets/icons/minus.svg';
import Plus from 'shared/assets/icons/plus.svg';
import Rubish from 'shared/assets/icons/rubish.svg';
import cls from './GoodCard.module.scss';

export enum GoodCardTheme {
    shop = 'shop',
    cart = 'cart',
}

interface IProduct {
    bought: number
    id: number | string
    in_cart?: number
    max_amount: number
    name: string
    price: number
    required_level: number
    type: string
    unique_key: string
}

interface GoodCardProps {
    product: IProduct,
    index?: number,
    amount?: number,
    className?: string,
    theme: GoodCardTheme,
    changeAmount?: (value: number) => void,
    deleteHandler?: (index: number, amount: number) => void,
    amountValue?: number,
}

function debounce(func: any, delay: number) {
    let timeoutId: any;

    return function() {
      const context = this;
      const args = arguments;

      clearTimeout(timeoutId);

      timeoutId = setTimeout(function() {
        func.apply(context, args);
      }, delay);
    };
  }

export const GoodCard = ({
    className, product, amount, index, theme, changeAmount, deleteHandler, amountValue
}: GoodCardProps) => {
    const dispatch = useDispatch();
    const currentCart = useSelector(getCurrentInCart);
    const {id, in_cart, unique_key, price, name, bought, max_amount } = product;
    const { sum } = useSelector(getCart);
    const [isButtonsVisible, setIsButtonsVisisble] = useState(true);
    const api = useApi();

    const onCartUpdate = (newValue: number) => {
        api.UpdateCart({ productId: String(id), amount: newValue });
    };

    const updateCart = (action: string) => {
        if (action === 'plus') {
            dispatch(userActions.addGoodToCart({ name, value: currentCart[name] + 1 }));
            //@ts-ignore
            debouncedOnCartUpdate(currentCart[name] + 1);
            dispatch(userActions.setCartSum(sum + price));
        } else {
            dispatch(userActions.addGoodToCart({ name, value: currentCart[name] - 1 }));
            //@ts-ignore
            debouncedOnCartUpdate(currentCart[name] - 1);
            dispatch(userActions.setCartSum(sum - price));
        }
    }

    const debouncedOnCartUpdate = debounce((newValue: number) => {
        onCartUpdate(newValue);
    }, 1000);

    return (
        <>
            {
                theme === 'shop' && (
                    <div className={cls.shopCard}>
                        <div className={classNames(cls.shopImgBox, { [cls.noBackground]: images[unique_key] !== undefined })}>
                            <img src={images[unique_key] ?? CardPlug} className={cls.img} alt="Разумные деньги фото №1" />
                        </div>
                        <div className={cls.info}>
                            <Text className={cls.name} color="#000" size={TextSize.text_18}>{name}</Text>
                            <Text className={cls.price} color="#5A636B" size={TextSize.text_20_600}>{formatNumber(price)} ₽</Text>
                            <Button
                                className={classNames(cls.buyButton, {
                                    [cls.visible]: currentCart[name] === 0,
                                    [cls.disabled]: max_amount === bought,
                                })}
                                theme={ButtonTheme.BUY}
                                icon={<Cart />}
                                onClick={() => {
                                    dispatch(userActions.addGoodToCart({ name, value: currentCart[name] + 1 }));
                                    api.UpdateCart({ productId: String(id), amount: 1 });
                                    dispatch(userActions.setCartSum(sum + price));
                                    setIsButtonsVisisble(false);
                                }}
                            >
                                Добавить в корзину
                            </Button>
                            <div className={classNames(cls.countWrapper, { [cls.visible]: (!isButtonsVisible && in_cart !== 0) || currentCart[name] !== 0})}>
                                <Button
                                    className={`${cls.countButton} ${cls.noStroke}`}
                                    theme={ButtonTheme.COUNTER}
                                    icon={<Minus />}
                                    onClick={() => {
                                        updateCart('minus');
                                        if (currentCart[name] <= 1) {
                                            setIsButtonsVisisble(true);
                                        }
                                    }}
                                />
                                <Text className={cls.amountCount} color="#353850" size={TextSize.text_20}>{currentCart[name]}</Text>
                                <Button
                                    className={classNames(cls.countButton, { [cls.hidden]: (bought + currentCart[name]) === max_amount })}
                                    // className={classNames(cls.countButton, { [cls.hidden]: amountItem === bought || amountItem === max_amount })}
                                    theme={ButtonTheme.COUNTER}
                                    icon={<Plus />}
                                    onClick={() => updateCart('plus')}
                                />
                                {/* <Button className={cls.buyButton2} theme={ButtonTheme.COUNTER} icon={<Cart />} /> */}
                            </div>
                        </div>
                    </div>
                )
            }
            {
                theme === 'cart' && (
                    <div className={cls.cartCard}>
                        <div className={cls.cartFlexBlock}>
                            <div className={classNames(cls.cartImgBox, { [cls.noBackground]: images[unique_key] !== undefined })}>
                                <img src={images[unique_key] ?? CardPlug} className={cls.img} alt="Разумные деньги фото №2" />
                            </div>
                            <Text className={`${cls.title} ${cls.cardNameDesc}`} color="#353850" size={TextSize.text_18_600}>{name}</Text>
                        </div>
                        <div className={cls.cartFlexBlock}>
                            <Text className={`${cls.title} ${cls.cardNameMob}`} color="#353850" size={TextSize.text_18_600}>{name}</Text>
                            <Text className={cls.title} color="#5A636B" size={TextSize.text_20}>{formatNumber(price)} ₽</Text>
                            <div className={classNames(cls.countWrapper, { [cls.visible]: !isButtonsVisible || in_cart !== 0})}>
                                <Button
                                    className={`${cls.countButton} ${cls.noStroke}`}
                                    theme={ButtonTheme.COUNTER}
                                    icon={<Minus />}
                                    onClick={() => {
                                        changeAmount(amountValue - 1);
                                        updateCart('minus');
                                        if (currentCart[name] === 1) {
                                            setIsButtonsVisisble(true);
                                            deleteHandler(index, null);
                                            api.UpdateCart({ productId: String(id), amount: 0 });
                                        }
                                    }}
                                />
                                <Text className={cls.amountCount} color="#353850" size={TextSize.text_20}>{currentCart[name]}</Text>
                                <Button
                                    className={classNames(cls.countButton, { [cls.hidden]: (bought + currentCart[name]) === max_amount })}
                                    // className={classNames(cls.countButton, { [cls.hidden]: amountItem === bought || amountItem === max_amount })}
                                    theme={ButtonTheme.COUNTER}
                                    icon={<Plus />}
                                    onClick={() => {
                                        changeAmount(amountValue + 1);
                                        updateCart('plus');
                                    }}
                                />
                                <Button className={cls.delete} theme={ButtonTheme.ONLY_ICON} icon={<Rubish />} onClick={() => {
                                    deleteHandler(index, currentCart[name]);
                                    dispatch(userActions.setCartSum(sum - (currentCart[name] * price)));
                                    api.UpdateCart({ productId: String(id), amount: 0 });
                                }}/>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

